import Art from '../assets/images/categories/art-min.jpg';
import Comedy from '../assets/images/categories/standUpComedy-min.jpeg';
import Education from '../assets/images/categories/education-min.jpg';
import Family from '../assets/images/categories/kids-min.jpg';
import TVMovie from '../assets/images/categories/tvMovie-min.jpg';
import Music from '../assets/images/categories/music-min.jpg';
import Religion from '../assets/images/categories/religion-min.jpg';
import Technology from '../assets/images/categories/tech-min.jpg';
import Business from '../assets/images/categories/business-min.jpg';
import Politics from '../assets/images/categories/politics-min.jpg';
import Culture from '../assets/images/categories/culture-min.jpg';
import Fiction from '../assets/images/categories/fiction-min.jpg';
import History from '../assets/images/categories/history-min.jpg';
import Crime from '../assets/images/categories/crime-min.jpg';
import News from '../assets/images/categories/news-min.jpg';
import Leisure from '../assets/images/categories/leisure-min.jpg';
import Fitness from '../assets/images/categories/fitness-min.jpg';
import Science from '../assets/images/categories/chemistry-min.jpg';
import Football from '../assets/images/categories/football-min.jpg';

export function getTopCategories() {
  const category = getCategories();

  return [
    category[1321].title,
    category[1318].title,
    category[1303].title,
    category[1488].title,
    category[1545].title,
    category[1309].title,
    category[1310].title,
    category[1512].title,
    category[1301].title,
    category[1304].title,
    category[1305].title,
    category[1324].title,
    category[1483].title,
    category[1487].title,
    category[1533].title,
    category[1511].title,
    category[1489].title,
    category[1314].title,
    category[1502].subgenres[1509],
    category[1321].subgenres[1493],
  ];
}

export default function getCategories() {
  return {
    1301: {
      title: 'Arts',
      subgenres: {
        1306: 'Food',
        1402: 'Design',
        1405: 'Performing Arts',
        1406: 'Visual Arts',
        1459: 'Fashion & Beauty',
        1482: 'Books',
      },
      imageUrl: Art,
    },
    1303: {
      title: 'Comedy',
      subgenres: {
        1495: 'Improv',
        1496: 'Comedy Interviews',
        1497: 'Stand-Up',
      },
      imageUrl: Comedy,
    },
    1304: {
      title: 'Education',
      subgenres: {
        1501: 'Courses',
        1498: 'Language Learning',
        1499: 'How To',
        1500: 'Self-Improvement',
      },
      imageUrl: Education,
    },
    1305: {
      title: 'Kids & Family',
      subgenres: {
        1519: 'Education for Kids',
        1520: 'Stories for Kids',
        1521: 'Parenting',
        1522: 'Pets & Animals',
      },
      imageUrl: Family,
    },
    1309: {
      title: 'TV & Film',
      subgenres: {
        1561: 'TV Reviews',
        1562: 'After Shows',
        1563: 'Film Reviews',
        1564: 'Film History',
        1565: 'Film Interviews',
      },
      imageUrl: TVMovie,
    },
    1310: {
      title: 'Music',
      subgenres: {
        1523: 'Music Commentary',
        1524: 'Music History',
        1525: 'Music Interviews',
      },
      imageUrl: Music,
    },
    1314: {
      title: 'Religion & Spirituality',
      subgenres: {
        1438: 'Buddhism',
        1439: 'Christianity',
        1440: 'Islam',
        1441: 'Judaism',
        1444: 'Spirituality',
        1463: 'Hinduism',
        1532: 'Religion',
      },
      imageUrl: Religion,
    },
    1318: {
      title: 'Technology',
      subgenres: {
        1528: 'Tech News',
      },
      imageUrl: Technology,
    },
    1321: {
      title: 'Business',
      subgenres: {
        1410: 'Careers',
        1412: 'Investing',
        1490: 'Business News',
        1491: 'Management',
        1492: 'Marketing',
        1493: 'Entrepreneurship',
        1494: 'Non-Profit',
      },
      imageUrl: Business,
    },
    1324: {
      title: 'Society & Culture',
      subgenres: {
        1302: 'Personal Journals',
        1320: 'Places & Travel',
        1443: 'Philosophy',
        1543: 'Documentary',
        1544: 'Relationships',
      },
      imageUrl: Culture,
    },
    1483: {
      title: 'Fiction',
      subgenres: {
        1484: 'Drama',
        1485: 'Science Fiction',
        1486: 'Comedy Fiction',
      },
      imageUrl: Fiction,
    },
    1487: {
      title: 'History',
      subgenres: {
        1564: 'Film History',
        1524: 'Music History',
      },
      imageUrl: History,
    },
    1488: {
      title: 'True Crime',
      subgenres: {},
      imageUrl: Crime,
    },
    1489: {
      title: 'News',
      subgenres: {
        1490: 'Business News',
        1526: 'Daily News',
        1527: 'Politics',
        1528: 'Tech News',
        1529: 'Sports News',
        1530: 'News Commentary',
        1531: 'Entertainment News',
      },
      imageUrl: News,
    },
    1502: {
      title: 'Leisure',
      subgenres: {
        1503: 'Automotive',
        1504: 'Aviation',
        1505: 'Hobbies',
        1506: 'Crafts',
        1507: 'Games',
        1508: 'Home & Garden',
        1509: 'Video Games',
        1510: 'Animation & Manga',
      },
      imageUrl: Leisure,
    },
    1511: {
      title: 'Government',
      subgenres: {
        1527: 'Politics',
      },
      imageUrl: Politics,
    },
    1512: {
      title: 'Health & Fitness',
      subgenres: {
        1513: 'Alternative Health',
        1514: 'Fitness',
        1515: 'Nutrition',
        1516: 'Sexuality',
        1517: 'Mental Health',
        1518: 'Medicine',
      },
      imageUrl: Fitness,
    },
    1533: {
      title: 'Science',
      subgenres: {
        1534: 'Natural Sciences',
        1535: 'Social Sciences',
        1536: 'Mathematics',
        1537: 'Nature',
        1538: 'Astronomy',
        1539: 'Chemistry',
        1540: 'Earth Sciences',
        1541: 'Life Sciences',
        1542: 'Physics',
      },
      imageUrl: Science,
    },
    1545: {
      title: 'Sports',
      subgenres: {
        1546: 'Soccer',
        1547: 'Football',
        1548: 'Basketball',
        1549: 'Baseball',
        1550: 'Hockey',
        1551: 'Running',
        1552: 'Rugby',
        1553: 'Golf',
        1554: 'Cricket',
        1555: 'Wrestling',
        1556: 'Tennis',
        1557: 'Volleyball',
        1558: 'Swimming',
        1559: 'Wilderness',
        1560: 'Fantasy Sports',
      },
      imageUrl: Football,
    },
  };
}
